import { useState, useCallback, useEffect } from 'react';
import SectionWrapper from '@/components/feature/SectionWrapper';
import SEO, { siteUrl } from '@/components/feature/SEO';

const galleryImages = [
  {
    id: 'g1',
    src: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/69611d4a-b4db-48dc-9851-bd142b7c1198_ChatGPT-Image-May-4-2026-08_12_27-AM.png?v=d8f7160d55f2b758e7cf11ae8129b303',
    alt: 'Gallery image 1',
  },
  {
    id: 'g2',
    src: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/dd33fd73-82ac-4422-b39e-9380383aae1b_WhatsApp-Image-2026-05-04-at-8.11.56-AM.jpeg?v=2a9b7445319faf80df444404515e5e2d',
    alt: 'Gallery image 2',
  },
  {
    id: 'g3',
    src: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/ee47269f-c812-44ae-8e49-137597b35b35_ChatGPT-Image-May-4-2026-08_06_11-AM.png?v=4c99f663f1e834c83970c78a04f5de1b',
    alt: 'Gallery image 3',
  },
  {
    id: 'g4',
    src: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/497a2696-2cad-4348-a778-2c8c198858bf_ChatGPT-Image-May-4-2026-08_03_47-AM.png?v=bca246000eda60c502a04d56bb05e836',
    alt: 'Gallery image 4',
  },
  {
    id: 'g5',
    src: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/746629b2-623e-441b-8241-62c28c906b60_ChatGPT-Image-May-4-2026-08_00_13-AM.png?v=bfdd35f6b7731189e5a041551e2ca667',
    alt: 'Gallery image 5',
  },
  {
    id: 'g6',
    src: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/03b5367a-2a71-483c-aa45-dc8829a83b9b_ChatGPT-Image-May-4-2026-07_55_05-AM.png?v=949b109ded1263d0f9a2ed580362ed1c',
    alt: 'Gallery image 6',
  },
  {
    id: 'g7',
    src: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/3993fd46-5667-47bd-a5ae-349a5af079c0_ChatGPT-Image-May-4-2026-08_24_38-AM.png?v=44a6cd37d35b86a7a59b1357b17fe9c8',
    alt: 'Gallery image 7',
  },
  {
    id: 'g8',
    src: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/8ef6c6ed-003e-4403-9e3b-4f39c8380132_ChatGPT-Image-May-4-2026-08_26_09-AM.png?v=ed0bbac6fcd9f078ffbec50626d2e963',
    alt: 'Gallery image 8',
  },
  {
    id: 'g9',
    src: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/3a394b46-4f23-441a-9ae0-613e9be79a65_ChatGPT-Image-May-4-2026-08_29_10-AM.png?v=2e9eba241e907b4a0c571ad49d7a594d',
    alt: 'Gallery image 9',
  },
  {
    id: 'g10',
    src: 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/cf7f3ecd-8493-4483-a756-a40b214c1aa6_ChatGPT-Image-May-4-2026-08_31_13-AM.png?v=774858fde083b2edab5591d2ece994b3',
    alt: 'Gallery image 10',
  },
];

export default function Gallery() {
  const [lightbox, setLightbox] = useState<number | null>(null);

  const openLightbox = (index: number) => setLightbox(index);
  const closeLightbox = () => setLightbox(null);

  const nextImage = useCallback(() => {
    if (lightbox === null) return;
    setLightbox((lightbox + 1) % galleryImages.length);
  }, [lightbox]);

  const prevImage = useCallback(() => {
    if (lightbox === null) return;
    setLightbox((lightbox - 1 + galleryImages.length) % galleryImages.length);
  }, [lightbox]);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (lightbox === null) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
    };
    window.addEventListener('keydown', handleKey);
    document.body.style.overflow = lightbox !== null ? 'hidden' : '';
    return () => {
      window.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [lightbox, nextImage, prevImage]);

  return (
    <main>
      <SEO
        title="Gallery — Moin Khan Boxing Academy | Training & Facility Photos"
        description="Explore the Moin Khan Boxing Academy gallery featuring training sessions, facility photos, and behind-the-scenes moments from our boxing programs in Islamabad."
        keywords="boxing gym gallery, Moin Khan training photos, boxing academy photos, Islamabad boxing gym, training facility images"
        canonicalUrl={siteUrl ? `${siteUrl}/gallery` : undefined}
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            '@id': `${siteUrl}/gallery#page`,
            url: `${siteUrl}/gallery`,
            name: 'Gallery — Moin Khan Boxing Academy',
            description: 'A glimpse into the intensity, discipline, and passion of Moin Khan Boxing Academy. View training sessions, facility photos, and behind-the-scenes moments.',
            hasPart: galleryImages.map((img, i) => ({
              '@type': 'ImageObject',
              name: img.alt,
              contentUrl: img.src,
              position: i + 1,
            })),
          },
        ]}
      />
      {/* Hero Banner */}
      <section className="relative pt-24 md:pt-28 pb-10 md:pb-14 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/69611d4a-b4db-48dc-9851-bd142b7c1198_ChatGPT-Image-May-4-2026-08_12_27-AM.png?v=d8f7160d55f2b758e7cf11ae8129b303"
            alt="Gallery"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-boxing-black/70" />
          <div className="absolute inset-0 bg-gradient-to-t from-boxing-black via-transparent to-boxing-black/40" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 lg:px-12 text-center">
          <SectionWrapper>
            <span className="section-label">/ The Gym</span>
            <h1 className="heading-mixed text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
              <span className="text-highlight">Gallery</span>
            </h1>
            <p className="font-poppins text-white/60 text-sm md:text-base max-w-xl mx-auto mt-4">
              A glimpse into the intensity, discipline, and passion of Moin Khan Boxing Academy.
            </p>
          </SectionWrapper>
        </div>
      </section>

      {/* Gallery Grid — 10 images, 5 portraits + 5 squares, perfect 3-col masonry */}
      <section className="bg-boxing-black py-8 md:py-12">
        <div className="max-w-6xl mx-auto px-5 md:px-8 lg:px-12">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2.5 md:gap-3">
            <SectionWrapper delay={0} className="row-span-2">
              <GalleryCard img={galleryImages[0]} index={0} open={openLightbox} />
            </SectionWrapper>
            <SectionWrapper delay={80} className="aspect-square">
              <GalleryCard img={galleryImages[1]} index={1} open={openLightbox} />
            </SectionWrapper>
            <SectionWrapper delay={160} className="row-span-2">
              <GalleryCard img={galleryImages[2]} index={2} open={openLightbox} />
            </SectionWrapper>
            <SectionWrapper delay={240} className="aspect-square">
              <GalleryCard img={galleryImages[3]} index={3} open={openLightbox} />
            </SectionWrapper>
            <SectionWrapper delay={320} className="aspect-square">
              <GalleryCard img={galleryImages[4]} index={4} open={openLightbox} />
            </SectionWrapper>
            <SectionWrapper delay={400} className="row-span-2">
              <GalleryCard img={galleryImages[5]} index={5} open={openLightbox} />
            </SectionWrapper>
            <SectionWrapper delay={480} className="row-span-2">
              <GalleryCard img={galleryImages[6]} index={6} open={openLightbox} />
            </SectionWrapper>
            <SectionWrapper delay={560} className="row-span-2">
              <GalleryCard img={galleryImages[7]} index={7} open={openLightbox} />
            </SectionWrapper>
            <SectionWrapper delay={640} className="aspect-square">
              <GalleryCard img={galleryImages[8]} index={8} open={openLightbox} />
            </SectionWrapper>
            <SectionWrapper delay={720} className="aspect-square">
              <GalleryCard img={galleryImages[9]} index={9} open={openLightbox} />
            </SectionWrapper>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 md:p-8"
          onClick={closeLightbox}
        >
          <button
            type="button"
            onClick={closeLightbox}
            className="absolute top-4 right-4 md:top-6 md:right-6 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/10 rounded-full hover:bg-boxing-red/80 transition-colors cursor-pointer z-10"
          >
            <i className="ri-close-line text-white text-xl md:text-2xl" />
          </button>

          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
            className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/10 rounded-full hover:bg-boxing-red/80 transition-colors cursor-pointer z-10"
          >
            <i className="ri-arrow-left-line text-white text-xl" />
          </button>

          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
            className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/10 rounded-full hover:bg-boxing-red/80 transition-colors cursor-pointer z-10"
          >
            <i className="ri-arrow-right-line text-white text-xl" />
          </button>

          <div
            className="relative max-w-5xl max-h-[85vh] w-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={galleryImages[lightbox].src}
              alt={galleryImages[lightbox].alt}
              className="max-w-full max-h-[85vh] object-contain rounded-lg"
            />
          </div>

          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white/50 text-xs md:text-sm font-oswald uppercase tracking-wider">
            {lightbox + 1} / {galleryImages.length}
          </div>
        </div>
      )}
    </main>
  );
}

function GalleryCard({
  img,
  index,
  open,
}: {
  img: { src: string; alt: string };
  index: number;
  open: (i: number) => void;
}) {
  return (
    <button
      type="button"
      onClick={() => open(index)}
      className="group relative w-full h-full overflow-hidden rounded-xl cursor-pointer border border-white/5"
    >
      <img
        src={img.src}
        alt={img.alt}
        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-boxing-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
        <span className="w-10 h-10 flex items-center justify-center bg-boxing-red rounded-full shadow-red-glow transition-transform duration-300 group-hover:scale-110">
          <i className="ri-zoom-in-line text-white text-lg" />
        </span>
      </div>
    </button>
  );
}